__webpack_require__.p = "/wp-content/themes/accor-plus/modules/payment-portal/files/webapp-payments-release/";